'use client';
import {Link} from '@mui/material';
import {styled} from '@mui/material/styles';
import {useTranslation} from 'react-i18next';
import {trackHeaderContactMethodClick} from '../../analytics';
// Deep import, not the contact barrel: the header renders on every page and must
// not drag the contact-page composites (ContactBody, SendMessageForm) along.
import {whatsappMessageHref} from '../contact/contact-href';
import {AppIcon, FaPhoneIcon, SvgWhatsappIcon} from '../icon';
import {Typography} from '../primitives';

const PHONE_DIRECTION = 'ltr';

const ContactLink = styled(Link)(({theme}) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(0.7),
  color: theme.palette.colors.text.neutral.inverse,
  textDecoration: 'none',
  '@media (hover: hover)': {
    '&:hover': {color: theme.palette.colors.text.primary.inverse},
  },
}));

interface ContactLinksProps {
  hotline?: string;
  whatsappHref?: string;
  showText?: boolean;
}

export function ContactLinks({hotline, whatsappHref, showText = false}: ContactLinksProps) {
  const {t} = useTranslation();
  return (
    <>
      {hotline && (
        <ContactLink
          href={`tel:${hotline}`}
          underline="none"
          aria-label={showText ? undefined : t('hotline')}
          onClick={() => {
            trackHeaderContactMethodClick('hotline');
          }}
        >
          <AppIcon icon={FaPhoneIcon} />
          {showText && (
            <Typography
              as="span"
              dir={PHONE_DIRECTION}
              family="primary"
              size="body-2"
              weight="medium"
              sx={{color: 'inherit', letterSpacing: '-0.015em'}}
            >
              {hotline}
            </Typography>
          )}
        </ContactLink>
      )}
      {whatsappHref && (
        <ContactLink
          href={whatsappMessageHref(whatsappHref, t('whatsapp_message'))}
          target="_blank"
          rel="noopener noreferrer"
          underline="none"
          aria-label={t('whatsapp')}
          onClick={() => {
            trackHeaderContactMethodClick('whatsapp');
          }}
        >
          <SvgWhatsappIcon aria-hidden />
        </ContactLink>
      )}
    </>
  );
}

ContactLinks.displayName = 'ContactLinks';
